import withFormattedDate from '../../../HOCs/withFormattedDate';
import SignerTextAnnotationComponent from './SignerTextAnnotationComponent';

const SignerDateAnnotationComponent = withFormattedDate(SignerTextAnnotationComponent);

export default SignerDateAnnotationComponent;
